<!--
  Root template of the Provisionszeile OBC. Branches by view mode only — the exact shape of
  cp-provision-agent-object.component.html. The `initialized && dto` guard is mandatory.
-->
@if (initialized && dto) {

    @if (uiMode == 'side' || uiMode == 'mini-side') {

        <cp-provision-contract-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></cp-provision-contract-side>

    } @else {

        <cp-provision-contract-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></cp-provision-contract-full>

    }

}
